import { render, staticRenderFns } from "./SemesterFormSettings.vue?vue&type=template&id=5acfade2&"
import script from "./SemesterFormSettings.vue?vue&type=script&lang=js&"
export * from "./SemesterFormSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports